/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createBrowserHistory } from 'history';
import { contextPathUI } from './settings';

export default createBrowserHistory({ basename: contextPathUI });
